import { AUTH_TAB } from '../../../components/Auth/constants';
export const AUTH_MODAL_INITIAL_STATE = {
    authModalVisible: false,
    onClose: () => { },
    onLoginSuccess: () => { },
    onSignUpSuccess: () => { },
    onForgotPasswordSuccess: () => { },
    initialTab: AUTH_TAB.OTP_LOGIN,
};
export const getDefaultTemplateState = () => {
    return {
        templates: {
            data: [],
            total: 0,
            offset: 0,
        },
        noMoreTemplates: false,
        loading: {
            templates: true,
            filters: false,
        },
        filters: [],
        searchQuery: '',
        isFavourite: false,
        selectedDimensionForFavourite: '16:9',
        hideLoaders: false,
        isPurchased: false,
        selectedDimensionForPurchased: '16:9',
    };
};
